import React from 'react';
import { toast } from 'react-toastify';
import confetti from 'canvas-confetti';
import BadgeIcon from 'components/BadgeIcon/BadgeIcon';
import SecureStorage from 'utils/secureStorage';
import { BadgeEarnedEvent, BadgeTier, TIER_FROM_LEVEL, TIER_COLORS } from 'types/interfaces/badge';
import './BadgeEarnedToast.css';

interface BadgeEarnedToastProps {
  badge: BadgeEarnedEvent['badge'];
  tier: BadgeTier;
  toastId: string;
}

const navigateToBadges = (toastId: string) => {
  const username = SecureStorage.getUsername();
  if (username) {
    toast.dismiss(toastId);
    window.location.href = `/profile/u/${username}?tab=trophy-case`;
  }
};

const BadgeEarnedToastContent: React.FC<BadgeEarnedToastProps> = ({ badge, tier, toastId }) => (
  <div className="badge-earned-toast" onClick={() => navigateToBadges(toastId)}>
    <BadgeIcon
      icon={badge.icon}
      shape={badge.shape}
      tier={tier}
      size={40}
      earned
      className="badge-earned-toast__icon"
    />
    <div className="badge-earned-toast__text">
      <div className="badge-earned-toast__label">Badge Earned!</div>
      <div className="badge-earned-toast__name">{badge.title}</div>
      <div className="badge-earned-toast__subtitle">{badge.subtitle}</div>
    </div>
    <button
      className="badge-earned-toast__view-btn"
      onClick={(e) => {
        e.stopPropagation();
        navigateToBadges(toastId);
      }}
    >
      View Badge
    </button>
  </div>
);

const triggerBadgeConfetti = (tier: BadgeTier) => {
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const tierColor = TIER_COLORS[tier];
  const colors = [tierColor, '#ffffff', '#DD5BEA'];

  confetti({
    particleCount: 40,
    spread: 55,
    origin: { x: 0.85, y: 0.15 },
    colors,
    disableForReducedMotion: true,
  });
};

export const showBadgeEarnedToast = (event: BadgeEarnedEvent): void => {
  const tier = TIER_FROM_LEVEL[event.badge.level] || 'bronze';
  const toastId = `badge-earned-${event.badge.id}`;

  toast(<BadgeEarnedToastContent badge={event.badge} tier={tier} toastId={toastId} />, {
    toastId,
    autoClose: 8000,
    className: 'badge-earned-toast-container',
    closeOnClick: false,
    closeButton: true,
    pauseOnHover: true,
  });

  triggerBadgeConfetti(tier);
};
